var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { TransactionClientService } from "../../../../../services/modules/transaction-client.service";
import { I18N } from "aurelia-i18n";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { BaseTransactionVideo } from "../base/base-transaction-video";
var TransactionVideos = /** @class */ (function (_super) {
    __extends(TransactionVideos, _super);
    function TransactionVideos(notificationService, i18N, transactionClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.notificationService = notificationService;
        _this.i18N = i18N;
        _this.transactionClientService = transactionClientService;
        return _this;
    }
    TransactionVideos.prototype.attached = function () {
        var _this = this;
        var recordedSessionId = "";
        if (this.item.gamePlayerTicketLines) {
            recordedSessionId = this.item && this.item.gamePlayerTicketLines ? this.item.gamePlayerTicketLines[0].recordedSessionId : null;
            if (recordedSessionId)
                this.getSessionVideo(recordedSessionId);
        }
        else {
            var item = this.item;
            var transactionId = item && item.item && item.item.transactionId ? item.item.transactionId : null;
            if (transactionId) {
                this.transactionClientService.getTransaction({ id: item.item.transactionId }).then(function (response) {
                    recordedSessionId = response && response.gamePlayerTicketLines ? response.gamePlayerTicketLines[0].recordedSessionId : null;
                    if (recordedSessionId)
                        _this.getSessionVideo(recordedSessionId);
                });
            }
        }
    };
    TransactionVideos = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N, TransactionClientService])
    ], TransactionVideos);
    return TransactionVideos;
}(BaseTransactionVideo));
export { TransactionVideos };
